import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  Box, 
  Container, 
  Typography, 
  Grid, 
  Button 
} from '@mui/material';

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navigationItems = [
    { icon: '🏠', label: 'Главная', path: '/' },
    { icon: '💬', label: 'Чат', path: '/chat' },
    { icon: '🎓', label: 'Курсы', path: '/courses' },
    { icon: '📖', label: 'Дневник', path: '/diary' },
    { icon: '👤', label: 'Профиль', path: '/profile' }
  ];

  return (
    <Box sx={{ 
      position: 'fixed', 
      bottom: 0, 
      left: 0, 
      right: 0, 
      bgcolor: 'background.paper',
      borderTop: 1,
      borderColor: 'divider',
      py: 1
    }}>
      <Container maxWidth="lg">
        <Grid container justifyContent="space-around">
          {navigationItems.map((item, index) => (
            <Grid item key={index}>
              <Button
                sx={{ 
                  display: 'flex', 
                  flexDirection: 'column',
                  color: location.pathname === item.path ? 'primary.main' : 'text.primary'
                }}
                onClick={() => navigate(item.path)}
              >
                <Typography variant="h6">{item.icon}</Typography>
                <Typography variant="caption">{item.label}</Typography>
              </Button>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer; 